<template>
  <Modal v-model="supplierPrivacyPolicyModal" width="1000" :styles="{top: fromListing ? '20px' : '100px'}" :title="configCharacters() + $t('key1006490')">
    <div class="docx">
      <component :is="switchComponent"></component>
    </div>
    <template #footer>
      <Button @click="supplierPrivacyPolicyModal=false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>

import Mixin from "@/components/mixin/common_mixin";
import privacyPolicyCN from "@/views/shopping/common/privacyPolicyCN";
import privacyPolicyUS from "@/views/shopping/common/privacyPolicyUS";

export default {
  name: "supplierPrivacyPolicyModal",
  mixins: [Mixin],
  data() {
    return {
      supplierPrivacyPolicyModal: false
    };
  },
  components: {
    privacyPolicyCN,
    privacyPolicyUS
  },
  computed: {
    fromListing() {
      return this.$store.state.fromListing;
    },
    switchComponent() {
      let component = this.languagesVal === 'zh-CN' ? privacyPolicyCN : privacyPolicyUS;
      return component;
    }
  },
  created() {

  },
  methods: {}
};
</script>

<style scoped lang="less">
.docx {
  padding: 38px;
  background-color: #ffffff;
  color: #000;
  max-height: 600px;
  overflow-y: auto;
}
</style>